import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const CardImagesForm = () => {
  const [data, setData] = useState([]);

  // Fetch pending coupons from API
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await axios.get(
          'https://api.bakpoket.com/api/Admin/PendingCoupons'
        );
        setData(response.data);
      } catch (error) {
        console.error('Error fetching coupon data:', error);
      }
    };

    fetchCoupons();
  }, []);

  // Handle approve action
  const handleApprove = async (id, requestedSlotId) => {
    // console.log("Sending to backend:", { couponId: id, assignedSlotId: requestedSlotId });

    try {
      await axios.post(
        `https://api.bakpoket.com/api/Admin/ApproveCoupon`,
        {
          couponId: id,
          assignedSlotId: requestedSlotId
        }
      );
      alert('Coupon approved successfully!');

      // Remove the approved item from the table
      setData((prevData) => prevData.filter((item) => item.id !== id));
    } catch (error) {
      console.error('Approval failed:', error);
      alert('Failed to approve coupon.');
    }
  };

  return (
    <Card>
      <TableWrapper>
        <h3 className='text-center text-md-start'>Coupons Overview</h3>
        <table>
          <thead>
            <tr>
              <th className='text-center'>ID</th>
              <th className='text-center'>Coupon Name</th>
              <th className='text-center'>Merchant ID</th>
              <th className='text-center'>Requested Slot ID</th>
              <th className='text-center'>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td className='text-center'>{item.id}</td>
                  <td className='text-center'>{item.couponName}</td>
                  <td className='text-center'>{item.merchantId}</td>
                  <td className='text-center'>{item.requestedSlotId}</td>
                  <td className='text-center'>
                    <button
                      className="approve-btn"
                      onClick={() => handleApprove(item.id, item.requestedSlotId)}
                    >
                      Approve
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center' }}>
                  No Pending Coupons Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableWrapper>
    </Card>
  );
};

export default CardImagesForm;

// Styled Components
const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 900px;
  width: 100%;
  margin: auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 30px;

    input[type="file"] {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  .approve-btn {
    padding: 6px 12px;
    background-color: #ef4766;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #ef4766;
    }
  }

  @media (max-width: 768px) {
    padding: 20px;

    h2 {
      font-size: 16px;
    }

    button {
      font-size: 12px;
    }

    input[type="file"] {
      padding: 6px;
      font-size: 13px;
    }

    .approve-btn {
      font-size: 11px;
      padding: 5px 10px;
    }
  }

  @media(max-width:576px){
    padding: 10px;
  }
`;

const TableWrapper = styled.div`
  margin-top: 20px;
  overflow-x: auto;

  h3 {
    color: #2a4157;
    font-size: 18px;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 10px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 13px;
      margin-bottom: 7px;
    }

    table {
    width: 100%;
    font-size: 7px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 2px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }
  }
`;
